import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { Utenti } from "./utenti/Utenti";
import { CostsPage } from "./CostsPage";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import LearningVideos from "../../../tw/learning/admin/LearningVideos";
import QuizAdmin from "../../../tw/learning/admin/QuizAdminPage";
import {
  administrationPermissions,
  learningAdminRoles,
} from "../../../permissions";

export default function adminPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from admin root URL to /users */
          <Redirect exact={true} from="/admin" to="/admin/utenti" />
        }
        <ContentRoute path="/admin/utenti" component={Utenti} allowedRoles={administrationPermissions} />
        <ContentRoute path="/admin/costs" component={CostsPage} allowedRoles={administrationPermissions} />
        <ContentRoute path="/admin/learning" component={LearningVideos} allowedRoles={learningAdminRoles} />
        <ContentRoute path="/admin/learning-quiz" component={QuizAdmin} allowedRoles={learningAdminRoles} />
      </Switch>
    </Suspense>
  );
}
